<template>
  <page-section :title="$t('ProfileSessions_Title')">
    <rest-list :payload="fetchEndpoint" :loading="!applicationsLoaded">
      <rest-list-column-date
        :sortable="true"
        :prop="clickhouse ? 'timestamp' : 'create_time'"
        :unix="!clickhouse"
        :title="$t('ProfileSessions_Field_CreateTime')"
        :width="200"
      />

      <rest-list-column-enum
        :prop="clickhouse ? 'source_application_id' : 'application_id'"
        :title="$t('ProfileSessions_Field_Application')"
        :key="applicationsLoaded"
        :enum="applications"
        :sortable="false"
      />

      <rest-list-column
        prop="device_id"
        :title="$t('ProfileSessions_Field_DeviceId')"
        :route="rowClickDeviceIdRoute"
        :width="200"
        :sortable="false"
      />
    </rest-list>
  </page-section>
</template>

<script>
import RestList from '@/common/components/rest/RestList'
import RestListColumn from '@/common/components/rest/RestListColumn'
import RestListColumnEnum from '@/common/components/rest/RestListColumnEnum'
import RestListColumnDate from '@/common/components/rest/RestListColumnDate'
import { projectEndpoint, projectRoute } from '@/core/helpers'
import { RestApiPaginator } from '@/core/utils/RestApiPaginator'
import PageSection from '@/common/components/page/PageSection'

export default {
  name: 'SessionsListPage',
  components: {
    PageSection,
    RestListColumnDate,
    RestList,
    RestListColumnEnum,
    RestListColumn
  },
  data() {
    return {
      applications: {},
      applicationsLoaded: false
    }
  },
  created() {
    new RestApiPaginator(this.optionsEndpoint).fetchAllPages().then(data => {
      data.forEach(val => {
        this.applications[val.id] = val.name
      })
      this.applicationsLoaded = true
    })
  },
  computed: {
    clickhouse() {
      return this.$hasFeature('shouldReadSessionsFromClickhouse')
    },
    optionsEndpoint() {
      return projectEndpoint({
        method: 'get',
        url: 'applications',
        params: {}
      })
    },
    fetchEndpoint() {
      if (this.clickhouse) {
        return projectEndpoint({
          method: 'get',
          url: `sessions-clickhouse`,
          params: {
            profile_num: this.$route.query.profile_num
          }
        })
      }
      return projectEndpoint({
        method: 'get',
        url: `sessions`,
        params: {
          profile_id: this.$route.query.profile_id
        }
      })
    }
  },

  methods: {
    rowClickDeviceIdRoute(row) {
      return projectRoute({
        name: 'Device',
        query: {
          device_id: row.device_id
        }
      })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/modules/profiles/pages/SessionsListPage.vue